import React from "react";

import { AppBar, Toolbar, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";


const styles = () => ({
  root: {
    display: 'grid',
    backgroundColor: '#155E98'
  },
  toolbar: {
    paddingTop: '5px'
  },
  title: {
    flexGrow: 1,
    textAlign: 'left'
  },
  backIconContainer: {
    paddingRight: "2.7vw",
    cursor: "pointer",
    display: "grid",
    "& img": {
      width: "0.7em"
    }
  },
  logoContainer: {
    textAlign: "center",
    position: "absolute",
    left: "calc(50% - 8px)",
    top: "calc(50% - 10px)",

    "& img": {
      width: "1.7em"
    }
  }
});

const TviToolbar = withStyles({
  root: {
    display: "grid",
    gridTemplateColumns: "1fr  max-content max-content",
    position: "relative",
  },
})(Toolbar);

const HeaderBar = (props) => {
  const { classes } = props;
  return (
    <AppBar style={{display: 'none'}} position="static" className={classes.root}>
      <TviToolbar className={classes.toolbar}>
        <Typography className={classes.title} variant="h5" noWrap>
          Register
        </Typography>
        <div className={classes.logoContainer}>
          {/* <img src="/media/logo.svg" alt="Tvi logo" /> */}
          <img src={process.env.PUBLIC_URL + "/media/logo.svg"} alt="Tvi logo" />
        </div>
      </TviToolbar>
    </AppBar>
  );
}

export default (withStyles(styles)(HeaderBar));